<template>
  <div class="wrap" v-if="pid">
    <app-list
      :isCheckbox="isEdit"
      :status="option.status"
      :option="isEdit ? option : optionEdit"
      :remote="isEdit ? option.remote : remote"
      ref="list"
      @selectcheckData="selectcheckData"
    >
      <template slot="content" slot-scope="scope">
        <template v-if="isEdit">
          <div class="title">
            {{ scope.data.name }}
            <img class="img" :src="tagIcons[scope.data.flagDelete]" alt="" />
          </div>
          <div class="balanceCount">库存 {{ scope.data.balanceCount }}</div>
          <div class="sellprice">￥{{ scope.data.sellPrice }}</div>
        </template>
        <template v-else>
          <div class="title">
            {{ scope.data.mutiDataTypeBean.data.name }}
            <img class="img" :src="tagIcons[scope.data.mutiDataTypeBean.data.flagDelete]" alt="" />
          </div>
          <div class="balanceCount">库存 {{ scope.data.mutiDataTypeBean.data.balanceCount }}</div>
          <div class="sellprice">￥{{ scope.data.mutiDataTypeBean.data.sellPrice }}</div>
        </template>
      </template>

      <template v-if="!isEdit" slot="buttons" slot-scope="data">
        <!-- <div class="livecbtn">立即分享</div> -->
        <template v-for="(item, index) in buttons">
          <div
            @click="item.onClick(data.index, data.data)"
            v-if="item.show"
            class="livecbtn"
            :key="index"
          >
            {{ item.value }}
          </div>
        </template>
      </template>
    </app-list>
    <van-popup v-model="isLoading" class="isLoading"> 加载中... </van-popup>
  </div>
</template>
<script>
//接口
import { artWorkList, goodsRelateDelete, livegoodsList } from '@/api/index';
import { relateType } from '@/api/live';

import { formatDateTime } from '@/utils/index';
//组件
import list from '@/views/components/list';
import { Toast, Loading } from 'vant';
import { Dialog } from 'vant';
let liveId = null;
let addType = null;
export default {
  name: 'livelist',
  components: {
    appList: list,
    Loading,
  },
  data() {
    return {
      changeEnd: false,
      isLoading: false,
      isEdit: false,
      isCheckbox: false,
      pid: liveId,
      option: {
        isButtons: true,
        statusKey: 'flagDelete',
        optionIMg: 'mutiDataTypeBean.imageUrl',
        remote: {
          fetch: artWorkList,
          param: {
            name: null,
            // relaDataType: '31',
            flagDelete: null,
            // goodTypeId: '1',
            // hasFilter: true,
            liveId: liveId == 'all' ? null : liveId,
            page: {
              index: 1,
              size: 10,
            },
          },
        },
        status: false,
      },
      optionEdit: {
        isButtons: true,
        statusKey: 'flagDelete',
        optionIMg: 'mutiDataTypeBean.imageUrl',
        remote: {
          fetch: artWorkList,
          param: {
            // name: null,
            flagDelete: null,
            // relaDataType: '31',
            // goodTypeId: '1',
            // hasFilter: true,
            liveId: liveId == 'all' ? null : liveId,
            page: {
              index: 1,
              size: 10,
            },
          },
        },
        status: false,
        fixButtons: [
          {
            value: '关联',
            type: 'add',
            onClick: () => {
              // 查看普通导购直播
              this.$router.replace({
                path: '/rela/artWork/' + liveId,
                query: { addType: addType },
              });
              setTimeout(function() {
                location.reload();
              }, 0);
            },
          },
        ],
      },
      remote: {
        fetch: livegoodsList,
        param: {
          name: null,
          flagDelete: 'null',
          type: null,
          id: liveId,
          dataType: '3',
          page: {
            index: 1,
            size: 10,
          },
        },
      },
      tagIcons: {
        //拍品状态iocn
        '0': 'https://img.zai-art.com/zaiart/saas/image/md/b59c1d1c3b9ad24b6dea01d112def40d.png',
        '3': 'https://img.zai-art.com/zaiart/saas/image/md/e28697bc8a61e556543ed41c2db938ed.png',
      },
      buttons: [
        {
          value: '取消关联',
          show: true,
          onClick: (index, row) => {
            Dialog.confirm({
              title: '',
              message: '确定要取消关联该数据么？',
            })
              .then(() => {
                // on confirm
                this.rm(row.id, index);
              })
              .catch(() => {
                // on cancel
              });
          },
        },
      ],
    };
  },
  computed: {},
  beforeCreate() {
    if (this.$route.query && this.$route.query.id) {
      liveId = this.$route.query.id;
      addType = this.$route.query.addType;
      this.isCheckbox = !this.$route.query.ischeck == '1';
    } else {
      liveId = this.$route.params.id;
    }
  },
  created() {
    this.isEdit = !!this.$route.params.id;
    console.log(this.option);
  },
  methods: {
    formatDateTime,
    selectcheckData() {
      //返回编辑页
      addType = this.$route.query.addType;
      if (addType == '0' || addType == '1') {
        this.isLoading = true;
        this.relateAll();
      } else {
        this.$router.push(`/live/${this.pid}?dataType=31`);
      }
    },
    rm(id, index) {
      goodsRelateDelete({ id }).then(res => {
        this.$refs.list.del(index, res.data.message);
      });
    },
    // 关联
    relateAll() {
      const param = {
        id: this.pid || null,
        aucType: null,
      };
      let multipleSelection = this.$store.state.app.multipleSelection;
      if(multipleSelection.length <= 0){
        this.timeLonad()
        return
      }
      // 1商品  0拍品
      let arr = [];
      multipleSelection.map(item => {
        arr.push(item.id);
        multipleSelection.push(item.id);
      });
      multipleSelection = arr;
      param.dataIdList = multipleSelection;
      param.dataType = 31;

      relateType(param)
        .then(res => {
          this.$store.state.app.multipleSelection = [];
          
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    timeLonad(){
      const path = '/rela/artWork';
      this.$router.replace({
        query: { id: this.pid, ischeck: 1, addType: addType },
        path: path,
      });
      setTimeout(()=> {
        this.isLoading = false;
        location.reload();
        addType = this.$route.query.addType;
      }, 0);
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 22px;
  text-indent: 53px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 45px;
  .img {
    position: absolute;
    width: 46px;
    height: 16px;
    line-height: 16px;
    top: 3px;
    left: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    font-size: 10px;
    text-align: right;
    overflow: hidden;
    border-radius: 1px;
  }
}
.balanceCount {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
  position: absolute;
  bottom: 0;
}
.sellprice {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 20px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #ff3e3e;
}
.livecbtn {
  width: 85px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  margin-left: 10px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  &:last-child {
    border: 1px solid #222222;
    color: #222222;
  }
}
/deep/ .isLoading {
  font-size: 14px;
  background: transparent;
  color: #fff;
}
</style>
